import { render, staticRenderFns } from "./AccountPublishFundingScopeForm.vue?vue&type=template&id=59472fc9&"
import script from "./AccountPublishFundingScopeForm.vue?vue&type=script&lang=ts&"
export * from "./AccountPublishFundingScopeForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports